import React, { Component } from "react";
import { Helmet } from 'react-helmet-async';
import "w3-css/3/w3.css";
import "./Area.css";
import {
  FromAcreButton,
  FromSquareFootButton,
  FromHectareButton,
  FromSquareInchButton,
  FromSquareMeterButton,
  FromSquareMileButton,
  FromSquareYardButton
} from "./Button";
import { getConversion } from "./area/ConversionTracker";
import { trackConversion, trackButtonClick } from "../../utils/analytics";
export default class Areas extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>Free Area Converter - Convert Acres, Hectares, Square Feet & More | Kayannou</title>
          <meta name="description"
            content="Free online area converter. Convert between acres, hectares, square feet, square meters, square miles, square yards, and square inches. Fast, accurate, and easy-to-use area conversion tool." />
          <meta name="keywords"
            content="area converter, area conversion, square feet to acres, hectares to square meters, square miles converter, area calculator, unit converter, convert area, free area converter, online area tool, acre, acres, hectare, hectares, square foot, square feet, square inch, square inches, square meter, square meters, square mile, square miles, square yard, square yards" />
          <meta name="author" content="Kayannou" />
          <meta property="og:title" content="Free Area Converter - Convert Acres, Hectares, Square Feet & More" />
          <meta property="og:description" content="Free online area converter. Convert between acres, hectares, square feet, square meters, and more. Fast and accurate." />
          <meta property="og:type" content="website" />
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:title" content="Free Area Converter - Convert Acres, Hectares, Square Feet & More" />
          <meta name="twitter:description" content="Free online area converter. Convert between acres, hectares, square feet, square meters, and more." />
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebApplication",
              "name": "Area Converter",
              "description": "Free online area converter for acres, hectares, square feet, square meters, and more",
              "url": "https://kayannou.com/conversion/area",
              "applicationCategory": "UtilityApplication",
              "operatingSystem": "Any",
              "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
              }
            })}
          </script>
        </Helmet>
        <Container />
      </div>
    );
  }
}
class Container extends Component {
  state = {
    value: "",
    operation: ""
  };
  handleConversionButton = buttonId => {
    this.setState({ operation: buttonId });
    // Track button click
    trackButtonClick(`Area: ${buttonId}`, 'Area Conversion');
  };

  handleConversionValue = inputValue => {
    this.setState({ value: inputValue });
    // Track conversion when both value and operation are present
    if (inputValue && this.state.operation) {
      trackConversion('Area', this.state.operation, 'multiple_units', inputValue);
    }
  };

  render() {
    return (
      <div className="area-conversion-container">
        <div className="conversion-content">
          <ContainerHeader
            conversionValue={this.handleConversionValue}
            conversionresult={getConversion(
              this.state.value,
              this.state.operation
            )}
          />
          <MiddleColumn id="" conversionButton={this.handleConversionButton} />
        </div>
      </div>
    );
  }
}
class ContainerHeader extends Component {
  state = {
    inputValue: "",
    isFocused: false
  };

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({ inputValue: value });
    this.props.conversionValue(value);
  };

  handleFocus = () => {
    this.setState({ isFocused: true });
  };

  handleBlur = () => {
    this.setState({ isFocused: false });
  };

  clearInput = () => {
    this.setState({ inputValue: "" });
    this.props.conversionValue("");
    if (this.input) {
      this.input.focus();
    }
  };

  render() {
    let result = this.props.conversionresult;
    const { inputValue, isFocused } = this.state;

    return (
      <div className="conversion-header">
        <div className="conversion-container">
          {/* Input Section */}
          <div className="input-section">
            <div className="input-group">
              <label className="input-label">
                <i className="fa fa-expand"></i>
                Area Input
              </label>
              <div className={`input-wrapper ${isFocused ? 'focused' : ''} ${inputValue ? 'has-value' : ''}`}>
                <input
                  ref={input => (this.input = input)}
                  className="conversion-input"
                  onChange={this.handleChange}
                  onFocus={this.handleFocus}
                  onBlur={this.handleBlur}
                  value={inputValue}
                  name="area"
                  type="number"
                  placeholder="Enter area conversion..."
                  min="0"
                  step="any"
                />
                {inputValue && (
                  <button
                    className="clear-button"
                    onClick={this.clearInput}
                    type="button"
                    aria-label="Clear input"
                  >
                    <i className="fa fa-times"></i>
                  </button>
                )}
                <div className="input-border"></div>
              </div>
            </div>
          </div>

          {/* Result Section */}
          <div className="result-section">
            <div className="result-group">
              <label className="result-label">
                <i className="fa fa-calculator"></i>
                Conversion Result
              </label>
              <div className="result-display">
                {result ? (
                  <div className="result-content">
                    <span className="result-value">{result}</span>
                    <div className="result-indicator">
                      <i className="fa fa-check-circle"></i>
                    </div>
                  </div>
                ) : (
                  <div className="result-placeholder">
                    <i className="fa fa-arrow-left"></i>
                    <span>Enter value and select type</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Visual Enhancement */}
        <div className="header-decoration">
          <div className="decoration-line"></div>
          <div className="decoration-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className="decoration-line"></div>
        </div>
      </div>
    );
  }
}
class MiddleColumn extends Component {
  handleClickUnit = buttonId => {
    this.props.conversionButton(buttonId);
  };

  render() {
    return (
      <div className="conversion-buttons-section">
        <div className="buttons-header">
          <h3 className="section-title">
            <i className="fa fa-expand"></i>
            Select Area Unit
          </h3>
          <p className="section-description">
            Choose the area unit you want to convert from
          </p>
        </div>

        <div className="conversion-buttons-grid">
          <FromAcreButton id="acto" acUnit={this.handleClickUnit} />
          <FromHectareButton id="heto" heUnit={this.handleClickUnit} />
          <FromSquareFootButton id="ftto" ftUnit={this.handleClickUnit} />
          <FromSquareInchButton id="into" inUnit={this.handleClickUnit} />
          <FromSquareMeterButton id="mto" mUnit={this.handleClickUnit} />
          <FromSquareMileButton id="mito" miUnit={this.handleClickUnit} />
          <FromSquareYardButton id="ydto" ydUnit={this.handleClickUnit} />
        </div>
      </div>
    );
  }
}
